import { render, staticRenderFns } from "./packageData.vue?vue&type=template&id=08fb0257&scoped=true&"
import script from "./packageData.vue?vue&type=script&lang=js&"
export * from "./packageData.vue?vue&type=script&lang=js&"
import style0 from "./packageData.vue?vue&type=style&index=0&id=08fb0257&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb0257",
  null
  
)

export default component.exports